/* ace-v2.js: Ace v2 (Brief 15). Plain, deferred, loaded only by layout/ace-v2.liquid.
   Header (mega menu, drawer), toasts, the bag (Shopify's /cart/add.js), Notify me, the home shop module and range rows,
   collection sort, and the PDP (gallery, plans, sticky bar). Every visible string comes from the markup (section and
   theme settings); every price is rendered by Liquid (ace-money / ace-per-serve) and only moved here, never computed. */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ace-money:start */
  // Mirror of snippets/ace-money.liquid: storefront symbol (window.ace.currency, from cart.currency in
  // layout/theme.liquid), two places, "." decimal, "," thousands. Same cents, same numerals in both markets.
  function money(cents) {
    var cur = (window.ace && window.ace.currency) || {};
    var c = Math.round(Number(cents) || 0);
    var sign = c < 0 ? '-' : '';
    var abs = Math.abs(c);
    var whole = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var rem = String(abs % 100);
    if (rem.length < 2) rem = '0' + rem;
    return sign + (cur.symbol || '') + whole + '.' + rem;
  }
  /* ace-money:end */
  // Mirror of snippets/ace-per-serve.liquid: the one per-serve price, rounded to the nearest penny.
  function perServe(cents, servings) {
    return Math.round(cents / servings);
  }
  window.ace = window.ace || {};
  window.ace.v2 = { money: money, perServe: perServe };

  /* ---------------------------------------------------------------- Toast: 16px above any fixed bar showing */
  var toastT;
  function toast(msg) {
    if (!msg) return;
    var t = $('.v2-toast');
    if (!t) { t = d.createElement('div'); t.className = 'v2-toast'; t.setAttribute('role', 'status'); d.body.appendChild(t); }
    t.innerHTML = '<i class="v2-i v2-i-check"></i><span></span>';
    t.lastChild.textContent = msg;
    var bar = $$('.v2-sticky.is-on, .v2-e-mbar').filter(function (b) { return b.offsetHeight; })[0];
    t.style.bottom = (bar ? bar.getBoundingClientRect().height + 16 : 24) + 'px';
    t.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2400);
  }
  window.ace.v2.toast = toast;
  var fill = function (tpl, name) { return String(tpl || '').replace(/\[product\]/g, name || ''); };

  /* ---------------------------------------------------------------- Bag */
  function setCount(n) { $$('[data-v2-bag-count]').forEach(function (el) { el.textContent = n; }); }
  function addToBag(item, okMsg, errMsg, go) { return addItems([item], okMsg, errMsg, go); }
  // Brief 19: after a successful add from the PDP or the EMS builder (go), the shopper goes to the bag, as Appstle's box
  // redirect does, unless the theme setting "After add to bag" says Stay (layout: body[data-v2-after-add]).
  // The route comes from Liquid (/en-eu/cart in Ireland). In the dev-theme preview the alternates are opened with
  // ?view=…, so the bag opens on its v2 template too; after the switch nobody has a view and it's the plain bag.
  function cartUrl() {
    var u = (window.ace.routes && window.ace.routes.cart_url) || '/cart';
    return new URLSearchParams(location.search).get('view') ? u + '?view=v2' : u;
  }
  // The EMS builder (assets/ace-v2-ems.js) adds its box through this too: its cart adapter's lines, one request.
  // A failure never navigates: the shopper stays with the error.
  function addItems(items, okMsg, errMsg, go) {
    var body = { items: items };
    return fetch((window.ace.routes && window.ace.routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (go && d.body.getAttribute('data-v2-after-add') !== 'stay') { location.assign(cartUrl()); return null; }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) { setCount(cart.item_count); toast(okMsg); } })
      .catch(function (e) { toast((e && e.description) || errMsg); });
  }
  window.ace.v2.addItems = addItems;

  /* ---------------------------------------------------------------- Header */
  function initHeader() {
    var btn = $('.v2-nav button[aria-controls]');
    var mega = btn && d.getElementById(btn.getAttribute('aria-controls'));
    if (btn && mega) {
      var set = function (open) { btn.setAttribute('aria-expanded', String(open)); mega.hidden = !open; };
      btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mega.hidden) { set(false); btn.focus(); } });
      d.addEventListener('click', function (e) { if (!mega.hidden && !e.target.closest('.v2-head')) set(false); });
    }
    var mb = $('.v2-menu-btn'), dr = mb && d.getElementById(mb.getAttribute('aria-controls'));
    if (mb && dr) {
      var close = function () { dr.hidden = true; mb.setAttribute('aria-expanded', 'false'); d.body.style.overflow = ''; mb.focus(); };
      mb.addEventListener('click', function () { dr.hidden = false; mb.setAttribute('aria-expanded', 'true'); d.body.style.overflow = 'hidden'; $('.v2-drawer__close', dr).focus(); });
      $('.v2-drawer__close', dr).addEventListener('click', close);
      dr.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }

  /* ---------------------------------------------------------------- Quick add and Notify me (delegated) */
  function initActions() {
    d.addEventListener('click', function (e) {
      var add = e.target.closest('[data-v2-add]');
      if (add && !add.disabled) {
        e.preventDefault();
        addToBag({ id: +add.getAttribute('data-v2-add'), quantity: 1 }, fill(add.getAttribute('data-ok'), add.getAttribute('data-name')), add.getAttribute('data-err'));
      }
      var n = e.target.closest('[data-v2-notify]');
      if (n) {
        e.preventDefault();
        // Notify me uses the footer sign-up (Shopify's customer form), tagged with the product, so nothing new is stored.
        var form = $('[data-v2-news]');
        if (!form) return;
        var tag = $('[data-v2-news-tags]', form);
        if (tag) tag.value = tag.getAttribute('data-base') + ', notify-' + n.getAttribute('data-v2-notify');
        var hint = $('[data-v2-news-hint]', form.parentNode);
        if (hint) { hint.textContent = fill(hint.getAttribute('data-tpl'), n.getAttribute('data-name')); hint.hidden = false; }
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = $('input[type="email"]', form);
        if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 400);
      }
    });
  }

  /* ---------------------------------------------------------------- Home: shop module, range rows */
  function initShop(root) {
    var btns = $$('.v2-shop__list button', root);
    var ctrl = $('.v2-rail-ctrl', root), desc = $('.v2-rail-desc', root), live = $('[data-v2-live]', root);
    var cur = function () { return $('.v2-rail:not([hidden])', root); };
    var sync = function () { var r = cur(); if (ctrl && r) ctrl.hidden = r.scrollWidth <= r.clientWidth + 1; };
    function show(b) {
      btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var key = b.getAttribute('data-v2-group');
      $$('.v2-rail', root).forEach(function (r) { r.hidden = r.getAttribute('data-v2-rail') !== key; r.scrollLeft = 0; });
      var src = $('[data-v2-desc="' + key + '"]', root);
      if (desc) desc.innerHTML = src ? src.innerHTML : '';
      if (live) live.textContent = b.getAttribute('data-v2-announce') || '';
      sync();
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b); }); });
    $$('[data-v2-rail-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { var r = cur(); if (r) r.scrollBy({ left: +b.getAttribute('data-v2-rail-step') * r.clientWidth * 0.66, behavior: 'smooth' }); });
    });
    window.addEventListener('resize', sync);
    if (btns[0]) show(btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0]);
  }
  function initRange(root) {
    root.addEventListener('click', function (e) {
      var tr = e.target.closest('tr[data-href]');
      if (tr && !e.target.closest('a')) location.href = tr.getAttribute('data-href');
    });
  }

  /* ---------------------------------------------------------------- Collection sort (client side: carb is a metafield) */
  function initSort(root) {
    var sel = $('select[data-v2-sort]', root), grid = $('.v2-grid', root);
    if (!sel || !grid) return;
    var tiles = $$('.v2-tile', grid), intro = $('.v2-intro', grid);
    var orig = tiles.slice();
    sel.addEventListener('change', function () {
      var k = sel.value, list = orig.slice();
      var num = function (t, a, dflt) { var v = parseFloat(t.getAttribute(a)); return isNaN(v) ? dflt : v; };
      if (k === 'price') list.sort(function (a, b) { return num(a, 'data-price', 1e12) - num(b, 'data-price', 1e12); });
      if (k === 'carb') list.sort(function (a, b) { return num(b, 'data-carb', -1) - num(a, 'data-carb', -1); });
      if (k === 'name') list.sort(function (a, b) { return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title')); });
      list.forEach(function (t) { grid.appendChild(t); });
      if (intro) grid.insertBefore(intro, grid.children[Math.min(2, list.length)] || null);
      grid.classList.toggle('is-sorted', k !== 'featured');
    });
  }

  /* ---------------------------------------------------------------- PDP */
  function initGallery(root) {
    var slides = $('.v2-slides', root), n = $$('.v2-slide', root).length, i = 0;
    var prev = $('[data-v2-g="-1"]', root), next = $('[data-v2-g="1"]', root), out = $('[data-v2-g-n]', root);
    if (!slides || !prev) return;
    var go = function (dlt) {
      i = Math.max(0, Math.min(n - 1, i + dlt));
      slides.style.transform = 'translateX(' + (-i * 100) + '%)';
      if (out) out.textContent = (i + 1) + ' / ' + n;
      prev.disabled = i === 0; next.disabled = i === n - 1;
      $$('.v2-slide', root).forEach(function (s, k) { s.setAttribute('aria-hidden', String(k !== i)); });
    };
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    go(0);
  }
  function initBuy(root) {
    var form = $('form[data-v2-buy]', root);
    var sticky = $('.v2-sticky', root);
    var tpl = function (kind, key) { var t = $('template[data-v2-' + kind + '="' + key + '"]', root); return t ? t.innerHTML : null; };
    var planInput = form && $('input[name="selling_plan"]', form);
    function sync() {
      var r = $('input[name="v2-plan"]:checked', root);
      var key = r ? r.value : 'once';
      var row = $('.v2-price-row', root), h;
      if (row && (h = tpl('row', key)) != null) row.innerHTML = h;
      $$('[data-v2-atc-price]', root).forEach(function (el) { if ((h = tpl('atc', key)) != null) el.innerHTML = h; });
      $$('[data-v2-sticky-plan]', root).forEach(function (el) { if ((h = tpl('sticky', key)) != null) el.innerHTML = h; });
      if (planInput) { var sp = r ? r.getAttribute('data-selling-plan') : ''; planInput.value = sp || ''; planInput.disabled = !sp; }
    }
    $$('input[name="v2-plan"]', root).forEach(function (r) { r.addEventListener('change', sync); });
    sync();
    var variantSel = $('select[data-v2-variant]', root);
    if (variantSel) variantSel.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('variant', variantSel.value); location.href = u.toString(); });
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var item = { id: +form.querySelector('[name="id"]').value, quantity: 1 };
        var r = $('input[name="v2-plan"]:checked', root);
        var sp = r && r.getAttribute('data-selling-plan');
        if (sp) item.selling_plan = +sp;
        addToBag(item, fill(sp ? form.getAttribute('data-ok-sub') : form.getAttribute('data-ok'), form.getAttribute('data-name')), form.getAttribute('data-err'), true);
      });
    }
    if (sticky) {
      $$('[data-v2-sticky-go]', sticky).forEach(function (b) {
        b.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
      });
      // On phones the bar shows from load until the main button is in view; on desktop once it has scrolled past.
      var main = $('.v2-buy .v2-atc', root);
      var syncSticky = function () {
        if (!main) return;
        var r = main.getBoundingClientRect(), mobile = innerWidth <= 760;
        var on = mobile ? (r.bottom < 0 || r.top > innerHeight - 72) : r.bottom < 0;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        $$('button, a', sticky).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      };
      addEventListener('scroll', syncSticky, { passive: true });
      addEventListener('resize', syncSticky);
      syncSticky();
    }
  }

  /* ---------------------------------------------------------------- Bag (Brief 19): edits in place */
  // The bag's quantity links (/cart/change) and the box's Remove form (/cart/update) work without this; here they run
  // through the .js endpoints and the page reloads, which keeps the preview's ?view. A failure says so and stays.
  function initCart(root) {
    var R = window.ace.routes || {};
    var post = function (url, body) {
      root.setAttribute('aria-busy', 'true');
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { location.reload(); })
        .catch(function (e) { root.removeAttribute('aria-busy'); toast((e && e.description) || root.getAttribute('data-err')); });
    };
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-v2-cart-qty]');
      if (!a) return;
      e.preventDefault();
      var line = +a.getAttribute('data-v2-cart-qty');
      var to = a.hasAttribute('data-to') ? +a.getAttribute('data-to') : Math.max(0, +$('output', a.closest('.v2-cline')).textContent + +a.getAttribute('data-d'));
      post(R.cart_change_url ? R.cart_change_url + '.js' : '/cart/change.js', { line: line, quantity: to });
    });
    root.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-v2-box-remove]');
      if (!f) return;
      e.preventDefault();
      var updates = {};
      $$('input[name^="updates["]', f).forEach(function (i) { updates[i.name.slice(8, -1)] = 0; });
      post(R.cart_update_url ? R.cart_update_url + '.js' : '/cart/update.js', { updates: updates });
    });
  }

  /* ---------------------------------------------------------------- Preview only: keep ?view=v2 on internal links */
  // The v2 templates are alternates until the switch, so the dev-theme preview opens them with ?view=v2. This keeps
  // a click-through on v2; after the switch nobody has ?view=v2 in the URL and this does nothing.
  function keepView() {
    var q = new URLSearchParams(location.search);
    if (q.get('view') !== 'v2') return;
    $$('a[href^="/"]').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), location.origin);
      // Brief 19: the bag and search have v2 alternates too. Account is Shopify-hosted; pages keep their own templates.
      if (!/^\/(collections|products|cart|search)?(\/|$)/.test(u.pathname) || /^\/(account|pages)/.test(u.pathname)) return;
      if (!u.searchParams.has('view')) u.searchParams.set('view', 'v2');
      a.setAttribute('href', u.pathname + u.search + u.hash);
    });
  }

  function init() {
    initHeader();
    initActions();
    $$('[data-v2-shop]').forEach(initShop);
    $$('[data-v2-range]').forEach(initRange);
    $$('[data-v2-collection]').forEach(initSort);
    $$('[data-v2-gallery]').forEach(initGallery);
    $$('[data-v2-product]').forEach(initBuy);
    $$('[data-v2-cart]').forEach(initCart);
    keepView();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
